<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>RAPORLAMA EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">RAPORLAMA EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">SAHA PDF BİRLEŞTİR - LİNK OLARAK PAYLAŞIM YAPMAYALIM </h3>

            <div class="tile-body">
              <div style="margin:auto ; position : center" aria-labelledby="navbarDropdown">
                <!-- <input class="form-control py-2 border-left-0 border" type="search" value="..." id="example-search-input"> -->
                <input id="searchBar" class="form-control py-2 border-left-0 border" style="width:100%;border-radius:0.25rem"
                  type="search" v-model="searchString" placeholder="ARATMAK İSTEDİĞİNİZ SAHAYI YAZINIZ" />
                <div style="width: 500px;position: absolute; z-index:3; background-color : white">
                  <ul class="searchCss" style="">
                    <li v-for="result in results" :key="result.id">
                      <hr />
                      <div @click="selectSaha(result)"
                        style="padding-right: 5px;padding-left: 5px;font-size: 15px;color: black;">

                        {{ result.id + "~" + result.sahaName }}

                      </div>
                    </li>
                  </ul>
                </div>
                <br>
                <br>
                <div>{{birlestirTemp}}</div>
              </div>
            </div>
          </div>
          <button @click="sendBirlestir()" class="btn btn-secondary" type="button">
            <i class="fa fa-fw fa-lg fa-check-circle"></i>PDF BİRLEŞTİR
          </button>
        </div>
      </div>
      <br>
      <br>
      <br>

      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">MAKİNE DELGİ FİLTRELEME</h3>

            <div class="tile-body">
              <form>
                <div id="app">
                  <label class="control-label">MAKİNE SEÇİNİZ</label>
                  <select class="form-control" @change="getBySaha($event)">
                    <option value="" selected disabled>MAKİNE SEÇİNİZ</option>
                    <option v-for="makina in makineler" :value="makina.id" :key="makina.id">{{ makina.makina_code + " "
                      +
                      makina.makina_name }}</option>
                  </select>
                </div>
              </form>
              <div class="form-group">
                <label class="control-label">Filtreleme Başlangıç Tarihi</label>
                <br />
                <input v-model="baslangicdate" type="date" />
              </div>
              <hr>
              <div class="form-group">
                <label class="control-label">Filtreleme Bitiş Tarihi</label>
                <br />
                <input v-model="bitisdate" type="date" />
              </div>
            </div>
          </div>
          <button @click="sendData()" class="btn btn-primary" type="button">
            <i class="fa fa-fw fa-lg fa-check-circle"></i>FİLTRELE
          </button>
        </div>
      </div>

    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import PersonelEkle from "./PersonelEkle.vue";
import { debounce } from "lodash";
export default {
  data() {
    return {
      searchString: "",
      sahaname: "",
      personeller: [],
      results: [],
      birlestir: [],
      birlestirTemp: [],
      makineler: [],
      cap_delgi: "",
      makineId: "",
      baslangicdate: "",
      bitisdate: "",
      toplam_delgi: "",
      personelId: "",
    };
  },

  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getAllMakina.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.makineler = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });

    var url2 = store.state.base_url + "AslanSahalar/getAllSahaDropUpdate.php?key=123";
    axios
      .post(url2)
      .then((response2) => {
        this.sahalar = response2.data;
        //console.log(sahalar);
      })
      .catch((err) => {
        console.log(err.response);
      });


  },
  watch: {
    searchString: debounce(function () {
      this.search();
    }, 250),
    $route() {
      $("#navbarSupportedContent").collapse("hide");
    },
  },
  methods: {
    getBySaha(event) {
      this.makineId = event.target.value;

    },
    reload: function () {
      location.reload();
    },
    search: function () {
      if (this.searchString.length > 0) {
        axios
          .get(
            `https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/searchSaha.php?key=123&keyword=${this.searchString}`
          )
          .then((response) => {
            var deger = response.data.length;
            if (deger > 50) {
              this.results = response.data.slice(0, 50);
            } else {
              this.results = response.data;
            }
          });
      } else {
        this.results = null;
      }
    },
    changemakina(event) {
      this.makineId = event.target.value;
    },
    selectSaha(result) {
      this.birlestir.push(result.id)
      this.birlestirTemp.push(result.id + "-" + result.sahaName)
      this.searchString = "";

      console.log(this.birlestir)
    },
    sendData: function () {
      console.log(this.oprone);
      if (this.makineId == "") {
        this.$swal({
          text: "MAKİNE SEÇİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.baslangicdate == "") {
        this.$swal({
          text: "BALANGIÇ TARİHİ SEÇİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.bitisdate == "") {
        this.$swal({
          text: "BİTİŞ TARİHİ SEÇİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else {
        window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/getAllMakineDelgi.php?key=123&keyword=${this.makineId}&mlml=${this.baslangicdate}&mlms=${this.bitisdate}`, "_blank");

      }
    },
    sendBirlestir: function () {
        window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/sahaBirlestir.php?key=123&sahaOne=${this.birlestir[0]}&sahaTwo=${this.birlestir[1]}&sahaThree=${this.birlestir[2]}&sahaFour=${this.birlestir[3]}&sahaFive=${this.birlestir[4]}`, "_blank");
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AslanMakineler.vue